var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "admin-panel" },
    [
      _vm.profile
        ? _c("vue-good-table", {
            ref: "table",
            staticClass: "users-table",
            attrs: {
              mode: "remote",
              "style-class": "vgt-table bordered striped",
              "total-rows": _vm.totalCount,
              "pagination-options": _vm.paginationOptions,
              "select-options": _vm.selectOptions,
              columns: _vm.columns,
              rows: _vm.rows,
            },
            on: {
              "on-page-change": _vm.onPageChange,
              "on-sort-change": _vm.onSortChange,
              "on-column-filter": _vm.onColumnFilter,
              "on-per-page-change": _vm.onPerPageChange,
              "on-cell-click": _vm.onCellClick,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "selected-row-actions",
                  fn: function () {
                    return [
                      _c(
                        "b-button",
                        {
                          staticClass: "button narrow-button button-danger",
                          on: { click: _vm.onRemoveClick },
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.$t("button.remove")) +
                              "\n            "
                          ),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              4187468367
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _c("confirm-modal", {
        ref: "modalConfirm",
        attrs: {
          "use-no-button": "",
          "show-update-field": _vm.showUpdateField,
          "show-select-field": _vm.showSelectField,
          "select-options": _vm.modalSelectOptions,
          "default-value": _vm.defaultModalValue,
          "use-message": !_vm.showUpdateField && !_vm.showSelectField,
          "yes-button-text":
            _vm.showUpdateField || _vm.showSelectField
              ? _vm.$t("button.ok")
              : "",
          "no-button-text":
            _vm.showUpdateField || _vm.showSelectField
              ? _vm.$t("button.cancel")
              : "",
          rules: "required|email|emailNotExists",
        },
        on: { confirmed: _vm.updateUser, rejected: _vm.resetConfirmModal },
      }),
      _vm._v(" "),
      _c("create-user", { on: { userCreated: _vm.appendUser } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }